/**
 * Demo Page Fallback
 * 
 * Fallback version of the demo page that doesn't require DemoDataConnectionProvider.
 * Used when there are context provider issues.
 */

import React from 'react';
import { DemoLayout } from '../components/Demo/DemoLayout';
import './DemoPage.css';

export const DemoPageFallback: React.FC = () => {
  return (
    <div className="demo-page">
      <DemoLayout />
    </div>
  );
};

export default DemoPageFallback;
